import { ReactNode } from 'react';

import { Flex } from '@mantine/core';

const MaxWidthLayout = (props: {
    children: ReactNode;
    widthOverride?: number;
}) => {
    const width = props.widthOverride ? `${props.widthOverride}rem` : '80rem';

    return (
        <Flex justify={'center'}>
            <Flex direction={'column'} gap={'md'} w={width}>
                {props.children}
            </Flex>
        </Flex>
    );
};

export default MaxWidthLayout;
